import { reactive } from 'vue'
import type { Project, ProjectStatus } from '@/types'

export interface ProjectsState {
  projects: Project[]
  selectedProject: Project | null
  isLoading: boolean
  error: string | null
  filters: {
    search: string
    status: ProjectStatus | ''
    organizationId: string
  }
}

export const getInitialState = (): ProjectsState => ({
  projects: [],
  selectedProject: null,
  isLoading: false,
  error: null,
  filters: {
    search: '',
    status: '',
    organizationId: '',
  },
})

export const createState = (): ProjectsState => {
  return reactive(getInitialState())
}

export const resetState = (state: ProjectsState): void => {
  const initial = getInitialState()
  state.projects = initial.projects
  state.selectedProject = initial.selectedProject
  state.isLoading = initial.isLoading
  state.error = initial.error
  state.filters = initial.filters
}
